import { render, staticRenderFns } from "./SidebarNavList.vue?vue&type=template&id=6efe9cc5&scoped=true&"
import script from "./SidebarNavList.vue?vue&type=script&lang=js&"
export * from "./SidebarNavList.vue?vue&type=script&lang=js&"
import style0 from "./SidebarNavList.vue?vue&type=style&index=0&id=6efe9cc5&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6efe9cc5",
  null
  
)

export default component.exports